import Vue from 'vue'

import NC from '@/lib/notification-center'
import ProjectExperiment from './project-experiment'

const SCALE_MIN = 0;
const SCALE_MAX = 100;

export default  {
  name: 'experiment',
  props: [],
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {

    // TODO: listen resize
    this._getBounds();

    Vue.nextTick(() => {
      PIXI.loader.add('/static/texture.json').load(() => {
        let texture = new PIXI.Texture.fromFrame('jason.png');
        this.renderer.bindTexture(texture);
      });
      this._initCanvas();
      this._resizeCanvas();
    });


    NC.on('project:hover', this.toggleProject);
    NC.on('scroll', () => {
      this.toggleProject({show: false});
    });

    this.currentProjects = [];
  },

  methods: {

    _initCanvas() {

      this.tick = 1;

      this.renderer = PIXI.autoDetectRenderer(256, 256, {
        resolution: window.devicePixelRatio,
        transparent: true
      });
      this.$refs.renderer.appendChild(this.renderer.view);

      this.stage = new PIXI.Container();
      this.stage.interactive = false;

      this.backgroundGraphic = new PIXI.Graphics();
      this.backgroundGraphic.beginFill(0xFFFFFF, 0.8);
      this.backgroundGraphic.drawRect(0, 0, this.bounds.width, this.bounds.height);
      this.backgroundGraphic.alpha = 0;
      this.stage.addChild(this.backgroundGraphic);

      this.displacementTexture = PIXI.Texture.fromImage('/static/displacementmap.jpg');
      this.displacementSprite = new PIXI.Sprite(this.displacementTexture);
      this.displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT;
      this.displacementFilter = new PIXI.filters.DisplacementFilter(this.displacementSprite);
      this.displacementFilter.resolution = window.devicePixelRatio;
      this.displacementFilter.scale = {x: SCALE_MIN, y: SCALE_MIN};

      PIXI.ticker.shared.add(this._loop, this );
    },

    _loop() {
      if(!this.dirty) return false;

      this.tick += 0.01;

      this.renderer.render(this.stage);
      this.dirty = false;
    },

    _getBounds() {
      this.bounds = this.$el.getBoundingClientRect();
    },

    _resizeCanvas() {
      if(this.renderer) {
        this.renderer.resize(this.bounds.width, this.bounds.height);
        this.dirty = true;
      }
    },

    _onResize() {
      this._getBounds();
      this._resizeCanvas()
    },

    toggleProject(params) {

      if(params.show) {
        this.showProject(params);
      } else {
        this.closeProject(params);
      }

    },

    showProject(params) {

      const projectExperiment = new ProjectExperiment({
        parent: this,
        project: params.project
      });
      projectExperiment.animateIn();
      this.currentProjects[params.project.id] = projectExperiment;

    },

    closeProject(params) {

      if(typeof params.project !== 'undefined') {
        const projectExperiment = this.currentProjects[params.project.id];
        projectExperiment.animateOut();
      }
    }

  }
}




// WEBPACK FOOTER //
// ./src/components/experiment/experiment.component.js